import { IGizmo, ISubscription } from '../../types';

interface IGetSubscriptionsParams {
  config: IGizmo;
}

/**
 * Analyze the gizmo configuration and get subscriptions the gizmo needs
 *
 * @param {IGizmo} config gizmo's configuration
 * @returns
 */
function getSubscriptions({
  config,
}: IGetSubscriptionsParams): ISubscription[] {
  let subscriptions: ISubscription[] = [];

  if (config.type === 'select_field' && config.ops?.selectField?.gizmoUid) {
    const [uid] = config.ops.selectField.gizmoUid.split('.');
    subscriptions.push({
      type: 'gizmoData',
      uid,
    });
  } else if (
    config.type === 'select_field' &&
    config.ops?.selectField?.gizmoUids
  ) {
    for (const gizmoUid of config.ops.selectField.gizmoUids) {
      subscriptions.push({
        type: 'gizmoData',
        uid: gizmoUid,
      });
    }
  }
  if (
    config.type === 'select_field' &&
    config.ops?.selectField?.parentFieldFid
  ) {
    subscriptions.push({
      type: 'gizmoData',
      fid: config.ops.selectField.parentFieldFid,
    });
  }

  // TODO: are we going to add this type of field?
  // if (
  //   config.type === 'data_table_field' &&
  //   config.options?.dataTableField?.gizmoUid
  // ) {
  //   subscriptions.push({
  //     type: 'gizmoData',
  //     uid: config.options.dataTableField.gizmoUid,
  //   });
  // }

  // This means the display has the Flux script configured
  if (config.ops?.display?.flux) {
    const influxVars = config.ops.display.flux.match(/{{\s*[\w\.]+\s*}}/g);

    if (influxVars) {
      const iSubs = influxVarsToSubscriptions(influxVars);
      subscriptions = subscriptions.concat(iSubs);
    }
  }

  // This means the editable has the Flux script configured
  if (config.ops?.editable?.flux) {
    const influxVars = config.ops.editable.flux.match(/{{\s*[\w\.]+\s*}}/g);

    if (influxVars) {
      const iSubs = influxVarsToSubscriptions(influxVars);
      subscriptions = subscriptions.concat(iSubs);
    }
  }

  if (config.ops?.required?.flux) {
    const influxVars = config.ops.required.flux.match(/{{\s*[\w\.]+\s*}}/g);

    if (influxVars) {
      const iSubs = influxVarsToSubscriptions(influxVars);
      subscriptions = subscriptions.concat(iSubs);
    }
  }

  if (config.label.includes('{{')) {
    const influxVars = config.label.match(/{{\s*[\w\.]+\s*}}/g);

    if (influxVars) {
      const iSubs = influxVarsToSubscriptions(influxVars);
      subscriptions = subscriptions.concat(iSubs);
    }
  }

  if (config.ops?.value?.flux) {
    // If influx variables exists in the flux expression the gizmo will subscribe to
    // the changes of the gizmo data
    const influxVars = config.ops.value.flux.match(/{{\s*[\w\.]+\s*}}/g);

    if (influxVars) {
      const iSubs = influxVarsToSubscriptions(influxVars);
      subscriptions = subscriptions.concat(iSubs);
    }
  }

  if (config.ops?.value?.condition) {
    // If influx variables exists in the flux expression the gizmo will subscribe to
    // the changes of the gizmo data
    const influxVars = config.ops.value.condition.match(/{{\s*[\w\.]+\s*}}/g);

    if (influxVars) {
      const iSubs = influxVarsToSubscriptions(influxVars);
      subscriptions = subscriptions.concat(iSubs);
    }
  }

  return subscriptions;
}

/**
 * Calculate subscriptions from influx variables
 *
 * @param {RegExpMatchArray} influxVars list of variables matched in the flux script
 * @returns {ISubscription[]}
 */
function influxVarsToSubscriptions(
  influxVars: RegExpMatchArray
): ISubscription[] {
  const subscriptions: ISubscription[] = [];

  for (const iVar of influxVars) {
    let influxVar = iVar
      .replace('{{', '')
      .replace('}}', '')
      .trim();

    if (influxVar.startsWith('user.')) {
      const parts = influxVar.split('.');
      parts.shift();

      subscriptions.push({
        type: 'user',
        path: parts.join('.'),
      });
    } else if (influxVar.match(/^\s*q_?\d*\s*/g)) {
      subscriptions.push({
        type: 'gizmoData',
        fid: influxVar,
      });
    } else {
      [influxVar] = influxVar.split('.');

      subscriptions.push({
        type: 'gizmoData',
        uid: influxVar,
      });
    }
  }

  return subscriptions;
}

export default getSubscriptions;
